import type {TableColumnsType, TableProps} from 'antd';
import {Table} from 'antd';
import React from 'react';

interface TableType {
  columns: TableColumnsType;
  data: any[];
  isLoading?: boolean;
  onChange?: (pagination?: any, filters?: any, sorter?: any) => void;
  scroll?: {x?: number | string | true; y?: number | string};
  virtual?: boolean;
  rowKey?: string | ((record: any) => string);
  className?: string;
}

export const TableCustom: React.FC<TableType> = props => {
  const {isLoading, columns, data, onChange, scroll, virtual = false, rowKey, className} = props;

  const handleTableChange: TableProps['onChange'] = (
    pagination,
    filters,
    sorter: any,
  ) => {
    if (onChange) {
      const {order, field} = sorter;
      let sort = null;
      if (order) {
        sort = {
          [field]: order === 'ascend' ? 1 : -1,
        };
      }
      onChange(filters, sort);
    }
  };

  return (
    <Table
      className={className}
      bordered={true}
      virtual={virtual}
      loading={isLoading}
      columns={columns}
      dataSource={data}
      pagination={false}
      onChange={handleTableChange}
      scroll={scroll ?? {x: 'max-content', y: 590}}
      rowKey={rowKey ?? 'key'}
    />
  );
};
